import { render } from "./QuizQuestion.vue?vue&type=template&id=281318a6"
import script from "./QuizQuestion.vue?vue&type=script&lang=js"
export * from "./QuizQuestion.vue?vue&type=script&lang=js"

import "./QuizQuestion.vue?vue&type=style&index=0&id=281318a6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__